import { render, staticRenderFns } from "./MentionThemes.vue?vue&type=template&id=e38ca2f0&scoped=true"
import script from "./MentionThemes.vue?vue&type=script&lang=js"
export * from "./MentionThemes.vue?vue&type=script&lang=js"
import style0 from "./MentionThemes.vue?vue&type=style&index=0&id=e38ca2f0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38ca2f0",
  null
  
)

export default component.exports